/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable max-len */

import _ from 'lodash';
import { MaxOrderQuantity } from '/client/src/constants/';

const isVisibleTicket = (ticket, theEvent) => {
  if (!ticket.ignore_active && !ticket.is_active) {
    return false;
  }

  if (ticket.is_need_code_to_show) {
    return false;
  }

  const begin_time_utc = _.get(ticket, 'sale_begin_time_utc', '2016-01-01T00:00:00Z');
  const end_time_utc = _.get(ticket, 'sale_end_time_utc', _.get(theEvent, 'schedules[0].end_time_utc', Date.now()));
  const now = new Date(Date.now()).getTime();
  const btime = new Date(begin_time_utc).getTime();
  const etime = new Date(end_time_utc).getTime();

  if (btime - now > 0 && ticket.is_set_sale_time) {
    return false;
  }

  return !(now - etime > 0 && ticket.is_set_sale_time);
};

export const _visibleTickets = (theEvent, tickets, filterId = '') => {
  const sortedTickets = tickets.sort((a, b) => a.placement_index - b.placement_index);

  return _.filter(sortedTickets, (t) => {
    if (filterId !== '') {
      return isVisibleTicket(t, theEvent) && t.id.toString() === filterId.toString();
    }

    if (isVisibleTicket(t, theEvent)) {
      return t;
    }
  });
};

export const _hiddenTickets = (tickets: []): any => {
  return _.filter(tickets, (t: {}): any => (t.is_need_code_to_show));
};

export const _visibleDonations = (donations: []): [] => {
  return _.filter(donations, (d: {}): {} => d.is_active);
};

export const getRemainQuantity = (theEvent, include_selected_quantity = false, _ticket) => {
  const stock_quantity = _.get(_ticket, 'current_inventory.stock_quantity', 0);
  const reserved_quantity = _.get(_ticket, 'current_inventory.reserved_quantity', 0);
  const { tickets_total_capacity, is_set_tickets_total_capacity } = theEvent;

  let quantity = stock_quantity - reserved_quantity;

  if (is_set_tickets_total_capacity) {
    let sold_quantity = 0;

    for (const ticket of theEvent.tickets) {
      const temp = ticket;

      sold_quantity += _.get(_ticket, 'stock_quantity', 0) - _.get(_ticket, 'current_inventory.stock_quantity', 0);

      // Whether to include the number of votes selected by the current ticket category
      if (include_selected_quantity && _.toString(ticket.id) !== _.toString(temp.id)) {
        console.log('store.count', _.size(theEvent.tickets));
        sold_quantity += _.size(theEvent.tickets);
      }
    }

    // Get total votes
    let total_quantity = tickets_total_capacity - sold_quantity;

    if (total_quantity < 0) {
      total_quantity = 0;
    }

    quantity = Math.min(total_quantity, quantity);
  }

  return quantity;
};

export const canAdd = (theEvent, ticket, VT, buyCart) => {
  return getAddCount(false, theEvent, ticket, VT, buyCart);
};

export const canRemove = (props, ticketId?) => {
  const currentCount = count(props, ticketId);

  return currentCount > 0;
};

export const count = (props, ticketId?) => {
  if (ticketId) {
    return _.filter(props.buyCart, ticket => ticket.id.toString() === ticketId.toString()).length;
  }

  return _.size(props.buyCart);
};

const getSelectedQuantity = (ticket, VT) => {
  let other_quantity = 0;

  for (const other_ticket of VT) {
    other_quantity += 1;
  }
  return other_quantity;
};

/**
 * Add ticket to shopping cart
 */
export const add = (theEvent, ticket, VT, cb, buyCart) => {
  const add_count = getAddCount(false, theEvent, ticket, VT, buyCart);

  if (add_count > 0) {
    return cb(add_count, ticket);
  }
};

/**
 * Remove from shopping cart
 */
export const remove = (props, cb) => {
  if (count(props, props.ticket.id) > 0) {
    let del_count = 1;

    if (count(props, props.ticket.id) === props.ticket.order_min_quantity) {
      del_count = count(props, props.ticket.id);
    }

    return cb(del_count, props.ticket);
  }
};

export const getAddCount = (trigger = true, theEvent, ticket, VT, buyCart) => {
  // The remaining votes of the currently selected ticket category
  const remain_quantity = getRemainQuantity(theEvent, true, ticket);

  // Total number of votes currently selected
  const selected_quantity = getSelectedQuantity(ticket, VT);

  // Is the number of remaining votes 0
  if (!remain_quantity) {
    return 0;
  }

  let add_count = 1;

  // If the number of tickets currently selected is 0;
  if (count({ buyCart }, ticket.id) === 0) {
    // Minimum number of tickets purchased
    add_count = ticket.order_min_quantity || 1;
    // If it is the first time to add a ticket
    if (trigger && this.__is_first_add_ticket) {
      // Get the default number of tickets purchased
      let default_quantity = ticket.default_ticket_quantity || 0;

      // If the number of tickets purchased by default is greater than the remaining tickets
      if (default_quantity > remain_quantity) {
        default_quantity = 0;
      }
      // If the default number of tickets purchased + the total number of votes is greater than 50
      if (default_quantity + selected_quantity > MaxOrderQuantity) {
        default_quantity = 0;
      }
      add_count = default_quantity;
      this.__is_first_add_ticket = false;
    }
  }

  // If the current ticket + the ticket to be added is greater than the remaining tickets
  // of the current ticket category, do not add
  if (count({ buyCart }, ticket.id) + add_count > remain_quantity) {
    // trigger && app.trigger("gt:remain:quantity", ticket);

    return 0;
  }
  // If the current ticket + the ticket to be added is greater than the remaining
  // tickets of the current ticket category, do not add
  if (add_count + selected_quantity > MaxOrderQuantity) {
    // trigger && app.trigger("gt:order:max:quantity", MaxOrderQuantity);

    return 0;
  }

  // If the current number of tickets + the number of tickets to be added is greater
  // than the maximum number of tickets purchased, do not add
  if ((count({ buyCart }, ticket.id) + add_count) > ticket.order_max_quantity) {
    // trigger && app.trigger("gt:ticket:max:quantity", ticket);

    return 0;
  }

  return add_count;
};

export const leftTime = (tickets) => {
  const now = new Date(Date.now()).getTime();
  const not_begin_tickets = _.filter(tickets, (t) => new Date(t.sale_begin_time_utc).getTime() > now);
  const first_begin_date = _.min(not_begin_tickets, (m) => new Date(m.sale_begin_time_utc).getTime());

  return first_begin_date - now;
};

// -1: not started, 0: normal ticket sales, 1: finished ticket sales, null loading
export const ticketsState = (tickets, donations, theEvent) => {
  let state = 1;

  if (tickets.length === 0 && donations.length === 0) {
    state = -2;
  }

  if (_visibleDonations(donations).length > 0 || _visibleTickets(theEvent, tickets).length > 0) {
    state = 0;
  } else if (leftTime(tickets) > 0) {
    state = -1;
  }

  return state;
};

// Total donation amount
export const donationTotal = (donations: any) => {
  let sum = 0;

  for (const donation of donations) {
    sum += _.get(donation, 'amount', _.get(donation, 'prefilled_amount', 0));
  }

  return sum;
};

export const canCheckout = (buyCart: any, donations: any) => {
  const ticketCnt = _.size(buyCart);
  const donationCnt = donationTotal(donations);

  return ticketCnt > 0 || donationCnt > 0;
};

export const PayCalculator = (
  Price: number,
  TaxFee: number,
  YourFee: number,
  siaSettings?: string,
  passFees: boolean
  // eslint-disable-next-line max-params
  ): Array => {
  const sparxoCiaFee = (fromCiaSettings: string): {} => {
    // by default settings '100-2500-200-5000-300' from cia.sparxo.com settings
    const dataArr = fromCiaSettings.split('-');

    return {
      feeLow: dataArr[0],
      feeMed: dataArr[2],
      feeHig: dataArr[4],
      priceLow: dataArr[1],
      priceHig: dataArr[3]
    };
  };
  const currentSparxoFee = (price: number, ciaSettings: string): number => {
    if (price === 0) return _.toNumber(0);

    const _ciaSettings = ciaSettings ? ciaSettings : '100-2500-200-5000-300';
    const _sparxoFee = sparxoCiaFee(_ciaSettings);

    switch (true) {
      case price > _sparxoFee.priceHig:
        return _.toNumber(_sparxoFee.feeHig);
      case price > _sparxoFee.priceLow:
        return _.toNumber(_sparxoFee.feeMed);
      default:
        return _.toNumber(_sparxoFee.feeLow);
    }
  };

  const totalFees = (sparxo_fee: number, tax_fee: number, your_fee: number) => sparxo_fee + tax_fee + your_fee;

  const ccFee = (price: number, merchant_fees: number, pass_fees: number): number => {
    if (price === 0) return _.toNumber(0);

    const fixedCharge = 30; // stripe fixed transaction fee 30 cent
    const fixedPercent =  0.029; // stripe fixed transaction percent %

    if (!pass_fees) {
      return  Math.ceil(price * fixedPercent + fixedCharge);
    }

    return Math.ceil(((price + merchant_fees) * fixedPercent + fixedCharge) / (1 - fixedPercent));
  };

  const SparxoFee = currentSparxoFee(Price, siaSettings ? siaSettings : null);
  const MerchantFees = totalFees(SparxoFee, TaxFee, passFees ? YourFee : 0);
  const CcFee = ccFee(Price, MerchantFees, passFees);
  const TotalCharge = Price + (passFees ? MerchantFees + CcFee : 0);
  const TotalFees = MerchantFees + CcFee;
  const Payout = passFees ? TotalCharge - TaxFee - CcFee - SparxoFee : TotalCharge - TotalFees;

  const result = [
    {
      key: 'SparxoFee',
      title:'Sparxo Fee:',
      value: SparxoFee
    },
    {
      key: 'CcFee',
      title:'CC Fee:',
      value: CcFee
    },
    {
      key: 'TaxFee',
      title:'Tax Fee:',
      value: TaxFee
    },
    {
      key: 'TotalFees',
      title:'Total Fees:',
      value: TotalFees
    },
    {
      key: 'TotalCharge',
      title:'Total Charge:',
      value: TotalCharge
    },
    {
      key: 'Payout',
      title:'Payout:',
      value: Payout
    }
  ];

  if (passFees) {
    result.splice(3, 0, {
      key: 'YourFee',
      title:'Your Fee:',
      value: YourFee
    });
  }

  return result;
};
